"use strict";

var _toConsumableArray = require("/vercel/path0/node_modules/@babel/runtime/helpers/toConsumableArray.js").default;
var _regeneratorRuntime = require("/vercel/path0/node_modules/@babel/runtime/helpers/regeneratorRuntime.js").default;
var _asyncToGenerator = require("/vercel/path0/node_modules/@babel/runtime/helpers/asyncToGenerator.js").default;
var _slicedToArray = require("/vercel/path0/node_modules/@babel/runtime/helpers/slicedToArray.js").default;
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useG$Balance = exports.useG$Decimals = exports.useG$Formatted = exports.useG$Amount = exports.useG$Tokens = exports.useSDK = exports.getSigner = exports.useGetContract = exports.useGetEnvChainId = exports.useReadOnlySDK = exports.NAME_TO_SDK = void 0;
var react_1 = require("react");
var ethers_1 = require("ethers");
var sdk_1 = require("./sdk");
var contexts_1 = require("../../contexts");
var core_1 = require("@usedapp/core");
var sdk_2 = require("../claim/sdk");
var sdk_3 = require("../savings/sdk");
var deployment_json_1 = __importDefault(require("@gooddollar/goodprotocol/releases/deployment.json"));
var useMulticallAtChain_1 = require("../../hooks/useMulticallAtChain");
var useUpdateEffect_1 = __importDefault(require("../../hooks/useUpdateEffect"));
var hooks_1 = require("../../hooks");
var constants_1 = require("../constants");
exports.NAME_TO_SDK = {
  claim: sdk_2.ClaimSDK,
  savings: sdk_3.SavingsSDK,
  base: sdk_1.BaseSDK
};
var useReadOnlySDK = function useReadOnlySDK(type, requiredChainId) {
  return (0, exports.useSDK)(true, type, requiredChainId);
};
exports.useReadOnlySDK = useReadOnlySDK;
var useGetEnvChainId = function useGetEnvChainId(requiredChainId) {
  var _a;
  var _ref = (0, core_1.useEthers)(),
    chainId = _ref.chainId;
  var web3Context = (0, react_1.useContext)(contexts_1.Web3Context);
  var baseEnv = web3Context.env || "";
  var connectedEnv = baseEnv;
  switch (requiredChainId !== null && requiredChainId !== void 0 ? requiredChainId : chainId) {
    case 1:
      connectedEnv = "production-mainnet"; // temp untill dev contracts are released to goerli
      break;
    case 42220:
      connectedEnv = connectedEnv === "fuse" ? "development-celo" : connectedEnv + "-celo";
      break;
  }
  var defaultEnv = connectedEnv;
  return {
    chainId: Number((_a = deployment_json_1.default[defaultEnv]) === null || _a === void 0 ? void 0 : _a.networkId),
    defaultEnv: defaultEnv,
    baseEnv: baseEnv,
    connectedEnv: connectedEnv,
    switchNetworkRequest: web3Context.switchNetwork
  };
};
exports.useGetEnvChainId = useGetEnvChainId;
var useGetContract = function useGetContract(contractName) {
  var readOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "base";
  var requiredChainId = arguments.length > 3 ? arguments[3] : undefined;
  var sdk = (0, exports.useSDK)(readOnly, type, requiredChainId);
  var _ref2 = (0, react_1.useState)(function () {
      return sdk === null || sdk === void 0 ? void 0 : sdk.getContract(contractName);
    }),
    _ref3 = _slicedToArray(_ref2, 2),
    contract = _ref3[0],
    setContract = _ref3[1];
  // skip first render as contract already initialized by useState()
  (0, useUpdateEffect_1.default)(function () {
    setContract(sdk === null || sdk === void 0 ? void 0 : sdk.getContract(contractName));
  }, [contractName, sdk]);
  return contract;
};
exports.useGetContract = useGetContract;
var getSigner = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(signer, account) {
    var address;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!ethers_1.Signer.isSigner(signer)) {
            _context.next = 6;
            break;
          }
          _context.next = 3;
          return signer.getAddress();
        case 3:
          address = _context.sent;
          if (!(address === account)) {
            _context.next = 6;
            break;
          }
          return _context.abrupt("return", signer);
        case 6:
          return _context.abrupt("return", new Error("no signer or wrong signer"));
        case 7:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getSigner(_x, _x2) {
    return _ref4.apply(this, arguments);
  };
}();
exports.getSigner = getSigner;
function sdkFactory(type, defaultEnv, readOnly, library, roLibrary) {
  var provider = library;
  var reqSdk = exports.NAME_TO_SDK[type];
  if (readOnly && roLibrary) {
    provider = roLibrary;
  }
  if (!provider && readOnly) {
    // the only reason why there is no provider when a read-only one is requested is because there
    // are no read-only urls set for the chain data is requested from
    console.error("No read-only provider could be found", {
      type: type
    });
  }
  if (!provider && !readOnly) {
    console.warn("Need a connected wallet for non-readonly sdk initializations", {
      type: type
    });
    return;
  }
  return new reqSdk(provider, defaultEnv);
}
var useSDK = function useSDK() {
  var readOnly = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "base";
  var requiredChainId = arguments.length > 2 ? arguments[2] : undefined;
  var _ref5 = (0, core_1.useEthers)(),
    library = _ref5.library;
  var _ref6 = (0, exports.useGetEnvChainId)(requiredChainId),
    chainId = _ref6.chainId,
    defaultEnv = _ref6.defaultEnv;
  var rolibrary = (0, useMulticallAtChain_1.useReadOnlyProvider)(chainId);
  var _ref7 = (0, react_1.useState)(function () {
      return sdkFactory(type, defaultEnv, readOnly, library instanceof ethers_1.providers.JsonRpcProvider ? library : undefined, rolibrary);
    }),
    _ref8 = _slicedToArray(_ref7, 2),
    sdk = _ref8[0],
    setSdk = _ref8[1];
  // skip first render as sdk already initialized by useState()
  (0, useUpdateEffect_1.default)(function () {
    setSdk(sdkFactory(type, defaultEnv, readOnly, library instanceof ethers_1.providers.JsonRpcProvider ? library : undefined, rolibrary));
  }, [library, rolibrary, readOnly, defaultEnv, type]);
  return sdk;
};
exports.useSDK = useSDK;
function useG$Tokens(requiredChainId) {
  var _ref9 = (0, exports.useGetEnvChainId)(requiredChainId),
    chainId = _ref9.chainId,
    defaultEnv = _ref9.defaultEnv;
  var decimals = (0, react_1.useContext)(contexts_1.TokenContext);
  var tokens = (0, react_1.useMemo)(function () {
    return constants_1.G$Tokens.map(function (token) {
      return (0, constants_1.G$Token)(token, chainId, defaultEnv, decimals);
    });
  }, [chainId, defaultEnv, decimals]);
  return tokens;
}
exports.useG$Tokens = useG$Tokens;
function useG$Amount(value) {
  var token = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "G$";
  var requiredChainId = arguments.length > 2 ? arguments[2] : undefined;
  var _ref10 = (0, exports.useGetEnvChainId)(requiredChainId),
    chainId = _ref10.chainId,
    defaultEnv = _ref10.defaultEnv;
  var decimals = (0, react_1.useContext)(contexts_1.TokenContext);
  return (0, constants_1.G$Amount)(token, value || ethers_1.BigNumber.from("0"), chainId, defaultEnv, decimals);
}
exports.useG$Amount = useG$Amount;
function useG$Formatted(value) {
  var token = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "G$";
  var requiredChainId = arguments.length > 2 ? arguments[2] : undefined;
  var formatOptions = arguments.length > 3 ? arguments[3] : undefined;
  var _ref11 = (0, exports.useGetEnvChainId)(requiredChainId),
    chainId = _ref11.chainId,
    defaultEnv = _ref11.defaultEnv;
  var decimals = (0, react_1.useContext)(contexts_1.TokenContext);
  return (0, constants_1.G$Amount)(token, value || ethers_1.BigNumber.from("0"), chainId, defaultEnv, decimals).format(formatOptions);
}
exports.useG$Formatted = useG$Formatted;
function useG$Decimals() {
  var token = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "G$";
  var requiredChainId = arguments.length > 1 ? arguments[1] : undefined;
  var _ref12 = (0, exports.useGetEnvChainId)(requiredChainId),
    chainId = _ref12.chainId;
  var decimals = (0, react_1.useContext)(contexts_1.TokenContext)[token];
  switch (token) {
    case "GDX":
      return decimals[constants_1.SupportedChains.MAINNET] || 2;
    default:
      return decimals[chainId];
  }
}
exports.useG$Decimals = useG$Decimals;
function useG$Balance() {
  var refresh = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "never";
  var requiredChainId = arguments.length > 1 ? arguments[1] : undefined;
  var refreshOrNever = (0, hooks_1.useRefreshOrNever)(refresh);
  var _ref13 = (0, core_1.useEthers)(),
    account = _ref13.account;
  var _ref14 = (0, exports.useGetEnvChainId)(requiredChainId),
    chainId = _ref14.chainId;
  var g$Contract = (0, exports.useGetContract)("GoodDollar", true, "base");
  var goodContract = (0, exports.useGetContract)("GReputation", true, "base");
  var gdxContract = (0, exports.useGetContract)("GoodReserveCDai", true, "base", 1);
  var MAINNET = constants_1.SupportedChains.MAINNET;
  var results = (0, core_1.useCalls)([{
    contract: g$Contract,
    method: "balanceOf",
    args: [account]
  }, {
    contract: goodContract,
    method: "balanceOf",
    args: [account]
  }], {
    refresh: refreshOrNever,
    chainId: chainId
  });
  var _ref15 = (0, core_1.useCalls)([{
      contract: gdxContract,
      method: "balanceOf",
      args: [account]
    }].filter(function (_) {
      return _.contract && chainId == MAINNET;
    }), {
      refresh: refreshOrNever,
      chainId: MAINNET
    }),
    _ref16 = _slicedToArray(_ref15, 1),
    mainnetGdx = _ref16[0];
  var _map = [].concat(_toConsumableArray(results), [mainnetGdx]).map(function (result) {
      var _a;
      return (_a = result === null || result === void 0 ? void 0 : result.value) === null || _a === void 0 ? void 0 : _a[0];
    }),
    _map2 = _slicedToArray(_map, 3),
    g$Value = _map2[0],
    goodValue = _map2[1],
    gdxValue = _map2[2];
  var g$Balance = useG$Amount(g$Value);
  var goodBalance = useG$Amount(goodValue, "GOOD");
  var gdxBalance = useG$Amount(gdxValue, "GDX");
  var balances = {
    G$: g$Balance,
    GOOD: goodBalance,
    GDX: gdxBalance
  };
  return balances;
}
exports.useG$Balance = useG$Balance;